import { FinancialDetails } from 'cpnl-common';
import { DefaultMarketApiErrors } from '@cp-shared-19/common-utilities';
import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<FinancialDetails, DefaultMarketApiErrors>({
    dataName: 'financialDetails',
    fetchCallback: (link: string) => {
        return CpDataApi.get(link).then((response) => response.data);
    },
});

export default reducer;
export const fetchFinancialDetails = fetchData;
